<template>
  <div class="env-wrap">
    <div class="minContent">
      <h3>各等级耕地环境质量耕地面积分析</h3>
      <div class="echartsContent" ref="chart1"></div>
    </div>
    <div class="minContent m20">
      <h3>各等级耕地环境质量耕地占比分析</h3>
      <div class="echartsContent" ref="chart2"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "environment",

    data() {
      return {
        chart1: '',
        chart2: '',
        data2: {},
      }
    },
    mounted() {
      this.chart1 = this.$echarts.init(this.$refs.chart1);
      this.chart2 = this.$echarts.init(this.$refs.chart2);
      this.initOption();
    },
    methods: {
      initOption() {
        let that = this;
        let data1 = {
          dataX: ['月湖区', '信江新区', '贵溪市', '余江县', 'E1'],
          dataName: ['良好', '较好', '警戒', '较差', '极差'],
          dataColor1: ['#20ffc8', '#43baff', '#f7e22e', '#ffc63c', '#ffa922'],
          dataColor2: ['#1ac7ac', '#21a8f7', '#d3bf16', '#dd9023', '#dc6d1b'],
          dataY1: [100, 212, 123, 531, 344],
          dataY2: [163, 345, 141, 313, 134],
          dataY3: [141, 431, 344, 123, 312],
          dataY4: [213, 215, 145, 134, 241],
          dataY5: [313, 231, 411, 237, 291],
        };
        this.data2.data = [];
        data1.dataY1.forEach(function (item, i) {
          that.data2.data.push({
            value: item,
            name: data1.dataName[i],
          })
        });
        this.data2.dataColor = ['#31bea8', '#32a1ec', '#e0d25a', '#eab542', '#f09830'];

        let option1 = {
          dataZoom: [{
            show: true,
            height: 10,
            xAxisIndex: [0],
            left: '50',
            right: '50',
            bottom: 15,
            fillerColor: '#2cc0b6',
            start: 0,
            end: 100,
            handleSize: '100%',
            handleStyle: {
              color: '#2cc0b6',
              shadowBlur: 0,
              shadowColor: '#2cc0b6',
              shadowOffsetX: 0,
              shadowOffsetY: 0
            },
            textStyle: {
              color: "#2cc0b6",
              fontSize: '12'
            },
            borderColor: "#2cc0b6"
          }, {
            type: "inside",
            show: true,
            height: 15,
            start: 1,
            end: 35
          }],
          tooltip: {
            trigger: 'axis',
            backgroundColor: 'transparent',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            },
            formatter: function (res) {
              that.bindChart2(res);
              that.removeChart2();

              var html = ``;
              html += `<div class="tooltip">
                            <p>${res[0].axisValue}各等级耕地环境质量面积</p>
                            <ul>
                                <li>总面积：<span class="blue">${res[0].data + res[1].data + res[2].data + res[3].data + res[4].data}（万亩）</span></li>
                                <li>${res[0].seriesName}：<span class="blue">${res[0].data}（万亩）</span></li>
                                <li>${res[1].seriesName}：<span class="blue">${res[1].data}（万亩）</span></li>
                                <li>${res[2].seriesName}：<span class="blue">${res[2].data}（万亩）</span></li>
                                <li>${res[3].seriesName}：<span class="blue">${res[3].data}（万亩）</span></li>
                                <li>${res[4].seriesName}：<span class="blue">${res[4].data}（万亩）</span></li>
                            </ul>
                        </div>`;
              return html;
            },
          },
          axisPointer: {
            shadowStyle: {
              color: 'rgba(8,104,98,.36)',
            }
          },
          legend: {
            top: 10,
            itemWidth: 7,
            itemHeight: 2,
            textStyle: {
              color: '#fff'
            },
            data: [
              {
                name: data1.dataName[0],
                icon: 'rect',
              },
              {
                name: data1.dataName[1],
                icon: 'rect',
              },
              {
                name: data1.dataName[2],
                icon: 'rect',
              },
              {
                name: data1.dataName[3],
                icon: 'rect',
              },
              {
                name: data1.dataName[4],
                icon: 'rect',
              }
            ],
          },
          grid: {
            top: 40,
            left: '3%',
            right: '4%',
            bottom: '40',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            axisTick: {show: false},
            axisLine: {
              lineStyle: {
                color: 'rgba(0,234,255,.8)'
              }
            },
            axisLabel: {
              color: '#fff'
            },
            data: data1.dataX
          },
          yAxis: [{
            type: 'value',
            name: '耕地面积：万亩',
            axisLine: {
              lineStyle: {
                color: 'rgba(0,234,255,.8)'
              }
            },
            axisLabel: {
              color: '#fff'
            },
            nameTextStyle: {
              color: '#99ffcc'
            },
            axisTick: {show: false},
            splitLine: {show: false},
          }, {
            type: 'value',
            axisLine: {
              lineStyle: {
                color: 'rgba(0,234,255,.8)'
              }
            },
            axisTick: {show: false},
          }],
          series: [
            {
              name: data1.dataName[0],
              type: 'bar',
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 0,
                      color: data1.dataColor1[0]
                    }, {
                      offset: 1,
                      color: data1.dataColor2[0]
                    }
                  ])
                }
              },
              data: data1.dataY1,
            },
            {
              name: data1.dataName[1],
              type: 'bar',
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 0,
                      color: data1.dataColor1[1]
                    }, {
                      offset: 1,
                      color: data1.dataColor2[1]
                    }
                  ])
                }
              },
              data: data1.dataY2,
            },
            {
              name: data1.dataName[2],
              type: 'bar',
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 0,
                      color: data1.dataColor1[2]
                    }, {
                      offset: 1,
                      color: data1.dataColor2[2]
                    }
                  ])
                }
              },
              data: data1.dataY3,
            },
            {
              name: data1.dataName[3],
              type: 'bar',
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 0,
                      color: data1.dataColor1[3]
                    }, {
                      offset: 1,
                      color: data1.dataColor2[3]
                    }
                  ])
                }
              },
              data: data1.dataY4,
            },
            {
              name: data1.dataName[4],
              type: 'bar',
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 0,
                      color: data1.dataColor1[4]
                    }, {
                      offset: 1,
                      color: data1.dataColor2[4]
                    }
                  ])
                }
              },
              data: data1.dataY5,
            }
          ]
        };
        let option2 = {
          tooltip: {
            trigger: 'item', //图形触发，axis是类目周触发
            axisPointer: {
              type: 'line',
              shadowStyle: {
                color: 'rgba(0, 255, 102, .05)'
              }
            },
            backgroundColor: "#002624",
            borderColor: '#009288',
            borderWidth: 1,
            formatter: (params) => {
              let html = "<div style='text-align:center;padding:15px'>";
              html += `${params.marker}${params.name}：<span style="color:#4CD5FF">${params.value}</span>`
              return html + '</div>'
            },
          },
          title: {
            text: [],
            top: "0",
            x: "center",
//              left: "34.5%",
            textStyle: {
              fontSize: 22,
              fontWeight: "normal",
              color: "#fff"
            }
          },
          grid: {
            top: "20",
            bottom: '20'
          },

          series: [
            {
              color: this.data2.dataColor,
              type: 'pie',
              radius: ['12%', '44%'],
              center: ['50%', '50%'],
              avoidLabelOverlap: false,
              itemStyle: {
                normal: {
                  borderColor: '#042546',
                  borderWidth: 2,
                },
              },
              labelLine: {
                length: 70,
              },
              label: {
                formatter: (params) => {
                  return `${params.name}\n${params.percent}%`
                }
              },
              data: this.data2.data,
            }
          ],

        };

        this.chart1.setOption(option1);
        this.chart2.setOption(option2);
      },
      // echats 图表自适应
      _resizeHanlder() {
        this.chart1.resize();
        this.chart2.resize()
      },
      // 销毁echats图表方法
      _destroyHandler() {
        if (this.chart1) {
          this.chart1.resize();
          this.chart2.resize();
        }
      },
      bindChart2(res) {
        let that = this;
        document.onclick = function () {
          res.forEach(function (item, i) {
            that.data2.data[i].value = item.data;
          });
          console.log(res);
          let option = that.chart2.getOption();
          option.series[0].data = that.data2.data;
          that.chart2.setOption(option);
        };
      },
      removeChart2() {
        document.onmousemove = function () {
          document.onclick = null
        }
      }
    }
  }
</script>
<style lang="scss">
  .tooltip {
    width: 206px;
    height: 183px;
    padding: 4px;
    font-size: 12px;
    background: url("../../assets/img/bg-tooltip.png") center center no-repeat;
    p {
      height: 34px;
      line-height: 34px;
      text-align: center;
    }
    ul {
      color: #ccc;
      padding-left: 40px;
      .blue {
        color: #4cd5ff;
      }
    }
  }
  .env-wrap {
    width: 100%;
    height: 433px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .minContent {
      width: calc((100% - 20px) / 2);
      height: 100%;
      background-color: #002624;
      box-sizing: border-box;
      border: solid 1px rgba(0, 255, 238, 0.5);
      h3 {
        height: 30px;
        background-image: linear-gradient(79deg, rgba(0, 255, 238, 0.5) 0%, rgba(0, 243, 247, 0.4) 25%, rgba(0, 230, 255, 0.3) 50%, rgba(0, 230, 255, 0.1) 100%);
        background-blend-mode: normal, normal;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-left: 12px;
        font-weight: normal;
      }
      .echartsContent {
        width: 100%;
        height: calc(100% - 30px);
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/pages/quality/environment.vue